<template>
  <div :class="['end_bt', isfixed&&'fixed_bt']">
    <div :class="['end_bt_content', disable&&'disable_bt']" @click="clickHandle">
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'EndBt',
  props: {
    isfixed: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: '提交'
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    clickHandle() {
      if (this.disable) return
      this.$emit('click-handle')
    }
  }
}
</script>

<style scoped lang="less">
.end_bt{
  .end_bt_content{
    width: 311px;
    height: 44px;
    background: #39BF3E;
    border-radius: 22px;
    font-family: PingFangSC-Regular;
    font-size: 17px;
    color: #FFFFFF;
    text-align: center;
    line-height: 44px;
    margin: 0 auto;
  }
  .disable_bt{
    background: #39BF3E;
    opacity: 0.6;
  }
}
.fixed_bt{
  position: fixed;
  bottom: 0;
  width: 100%;
}
</style>
